import React from "react";

function LoadingButton({ isLoading, children, ...props }) {
  return (
    <button
      {...props}
      disabled={isLoading || props.disabled}
      style={{
        opacity: isLoading ? 0.7 : 1,
        position: "relative",
        pointerEvents: isLoading ? "none" : "auto",
      }}
    >
      {isLoading ? (
        <div className="spinner" />
      ) : (
        children
      )}

      {/* Spinner CSS overlay */}
      <style jsx>{`
        .spinner {
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          animation: spin 0.6s linear infinite;
          margin: auto;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </button>
  );
}

export default LoadingButton;
